






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import { DxForm, DxSimpleItem, DxGroupItem, DxLabel } from 'devextreme-vue/form';
import { DxDataGrid, DxEditing, DxColumn, DxRequiredRule } from 'devextreme-vue/data-grid';
import { DxTextArea } from 'devextreme-vue/text-area';
import { LabourCost, UpdateArticleLabourCostCommand, IArticle, ArticlesClient } from '@/data/web-api-client';
import { cloneDeep } from 'lodash';

@Component({
  components: {
    cCard,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxTextArea,
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
  },
})
export default class LabourCostCard extends Vue {
  @Prop({ required: true })
  public value!: IArticle;

  public editableData: LabourCost[] = [];

  mounted() {
    this.setEditableData();
  }

  private setEditableData() {
    const activeProjectTypes: string[] = this.$store.getters['catalogs/list']('ProjectTypes').values;

    const activeLabourCosts = this.value.labourCosts?.filter((lc) => activeProjectTypes.includes(lc.type!));

    this.editableData = JSON.parse(JSON.stringify(activeLabourCosts)!);
  }

  public async onRowUpdated(e: any) {
    try {
      const command = new UpdateArticleLabourCostCommand({
        id: this.value.id ? this.value.id : '',
        labourCosts: this.editableData.map((lc) => LabourCost.fromJS(lc)),
      });
      const result = await new ArticlesClient(undefined, this.$axios).updateLabourcost(this.value.id ? this.value.id : '', command);

      this.$emit('input', result);
      notificationService.saved();

      e.cancel = false;
    } catch (err) {
      notificationService.showAxiosError(err);
      e.cancel = true;
    }
  }

  get columns() {
    const self = this;
    return [
      {
        caption: this.$t('objects.articles.LabourCost.ProjectType'),
        calculateCellValue(value: any) {
          if (!value) {
            return '';
          }
          return value.type;
        },
      },
      {
        dataField: 'cost',
        caption: 'Kost',
        format: {
          type: 'currency',
          precision: 2,
        },
        allowEditing: true,
        alignment: 'left',
      },
      {
        dataField: 'minimumLabourDuration',
        caption: 'Totale minimumtijd (min.)',
        alignment: 'left',
        validationRules: [
          {
            type: 'required',
            message: 'Dit veld is verplicht!',
          },
        ],
      },
      {
        caption: 'Target',
        columns: [
          {
            dataField: 'costTarget',
            caption: this.$t('objects.articles.LabourCost.Cost'),
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
            allowEditing: false,
          },
          {
            dataField: 'targetDuration',
            caption: 'Tijd (min.)',
            alignment: 'left',
            allowEditing: self.value.type !== 1,
            validationRules: [
              {
                type: 'required',
                message: 'Dit veld is verplicht!',
              },
            ],
          },
        ],
      },
      {
        caption: 'Gemiddelde',
        columns: [
          {
            dataField: 'averageCost',
            caption: this.$t('objects.articles.LabourCost.Cost'),
            format: {
              type: 'currency',
              precision: 2,
            },
            allowEditing: false,
            alignment: 'left',
          },
          {
            caption: 'Tijd (min.)',
            alignment: 'left',
            calculateCellValue(value: any) {
              if (!value) {
                return '';
              }

              return (Math.round((value.averageCost / self.defaultHourRate) * 100) / 100) * 60;
            },
          },
        ],
      },
    ];
  }

  get settings() {
    return this.$store.getters['settings/data'];
  }

  get defaultHourRate() {
    let value: number = 1;

    if (this.settings && this.settings.defaultHourRate && this.settings.defaultHourRate !== 0) {
      value = this.settings.defaultHourRate;
    }

    return value;
  }

  @Watch('value')
  private onValueChanged(value: IArticle) {
    this.setEditableData();
  }
}
